const tabsMap = {
  domains: {
    name: 'Domains',
    component: 'Domains',
    types: ['RtxPops'],
    timezone: true,
  },
  rules: {
    name: 'Rules',
    component: 'Rules',
    types: ['Evadav', 'ZeroPark', 'RtxPops', 'Propeller', 'ActiveRevenueMobile', 'ClickAdu', 'ExoClick', 'EzMob', 'HillTopAds', 'Adsterra', 'PlugRush', 'PopAds', 'PopCash', 'PushGround', 'RichPush', 'AdMaven', 'Kadam', 'BidVertiser'],
    timezone: false,
  },
  performance: {
    name: 'Performance',
    component: 'Performance',
    types: ['Evadav', 'ZeroPark', 'RtxPops', 'Propeller', 'ActiveRevenueMobile', 'ClickAdu', 'ExoClick', 'EzMob', 'HillTopAds', 'Adsterra', 'PlugRush', 'PopAds', 'PopCash', 'PushGround', 'RichPush', 'AdMaven', 'Kadam', 'BidVertiser'],
    timezone: true,
  },
  sources: {
    name: 'Sources',
    component: 'Sources',
    types: ['Evadav', 'ZeroPark', 'ActiveRevenueMobile', 'EzMob', 'PushGround', 'RichPush', 'AdMaven'],
    timezone: true,
  },
  creatives: {
    name: 'Creatives',
    component: 'Creatives',
    types: ['ActiveRevenueMobile', 'Evadav', 'ZeroPark', 'Propeller', 'PushGround', 'RichPush', 'MegaPush', 'AdMaven', 'EzMob', 'Kadam'],
    timezone: true,
  },
  publishers: {
    name: 'Publishers',
    component: 'Publishers',
    types: ['ZeroPark', 'RtxPops', 'Propeller', 'ActiveRevenueMobile', 'ClickAdu', 'ExoClick', 'EzMob', 'HillTopAds', 'Adsterra', 'PlugRush', 'PopAds', 'PopCash', 'PushGround', 'RichPush', 'AdMaven', 'Kadam', 'BidVertiser'],
    timezone: true,
  },
  keywords: {
    name: 'Keywords',
    component: 'Keywords',
    types: ['ZeroPark'],
    timezone: true,
  },
  subIds: {
    name: 'SubIds',
    component: 'SubIds',
    types: ['RtxPops'],
    timezone: true,
  },
  channels: {
    name: 'Channels',
    component: 'Channels',
    types: ['RtxPops'],
    timezone: true,
  },
};

Object.entries(tabsMap).forEach(([key, tab]) => { tab.id = key; });

const tabs = [
  tabsMap.publishers,
  tabsMap.sources,
  tabsMap.creatives,
  tabsMap.domains,
  tabsMap.keywords,
  tabsMap.subIds,
  tabsMap.channels,
  tabsMap.rules,
  tabsMap.performance,
];

const getAvailableTabs = (campaign, trafficSourceAccount) => {
  const filteredTabs = [];
  tabs.forEach((_tab) => {
    const tab = { ..._tab };

    // ActiveRevenue, Apps have replaced the widgets
    if (tab.id === 'publishers' && ['EzMob', 'AdMaven'].includes(campaign.traffic_source_unique_name)) {
      tab.name = 'Publishers Feed';
    } else if (tab.id === 'publishers' && ['BidVertiser'].includes(campaign.traffic_source_unique_name)) {
      tab.name = 'Sources';
    } else if (tab.id === 'sources' && ['EzMob', 'AdMaven'].includes(campaign.traffic_source_unique_name)) {
      tab.name = 'Sub ID';
    } else if (tab.id === 'publishers' && ['RtxPops', 'ZeroPark'].includes(campaign.traffic_source_unique_name)) {
      tab.name = 'Targets';
    }

    // Enable Tabs by TrafficSource except Creatives
    if (tab.id === 'creatives' && ['ActiveRevenueMobile', 'Evadav', 'ZeroPark', 'Propeller', 'RichPush', 'MegaPush', 'AdMaven', 'EzMob', 'Kadam'].includes(campaign.traffic_source_unique_name)) {
      // If isPush enable Tab
      if (campaign.is_push) filteredTabs.push(tab);
    } else if (tab.types.includes(trafficSourceAccount.type.uniqueName)) {
      filteredTabs.push(tab);
    }
  });

  return filteredTabs;
};

const allowedBidChangePropeller = ['smartCpm', 'cpc'];

const statusFilter = (model) => {
  const config = {
    publisher: [
      { value: 'all', content: 'All Publishers' },
      { value: 'paused', content: 'Only Blocked Publishers' },
      { value: 'active', content: 'Only Active Publishers' },
    ],
    creative: [
      { value: 'all', content: 'All Creatives' },
      { value: 'paused', content: 'Only Paused Creatives' },
      { value: 'active', content: 'Only Active Creatives' },
    ],
    source: [
      { value: 'all', content: 'All Sources' },
      { value: 'paused', content: 'Only Paused Sources' },
      { value: 'active', content: 'Only Active Sources' },
    ],
    keyword: [
      { value: 'all', content: 'All Keywords' },
      { value: 'paused', content: 'Only Paused Keywords' },
      { value: 'active', content: 'Only Active Keywords' },
    ],
    channel: [
      { value: 'all', content: 'All Channels' },
      { value: 'paused', content: 'Only Paused Channels' },
      { value: 'active', content: 'Only Active Channels' },
    ],
    domain: [
      { value: 'all', content: 'All Domains' },
      { value: 'paused', content: 'Only Paused Domains' },
      { value: 'active', content: 'Only Active Domains' },
    ],
    subId: [
      { value: 'all', content: 'All SubIds' },
      { value: 'paused', content: 'Only Paused SubIds' },
      { value: 'active', content: 'Only Active SubIds' },
    ],
  };
  return config[model];
};

// specify foreach Traffic Source its editable Fields (bid/budget/daily_budget)

const editableFields = {
  ActiveRevenueMobile: [
    { name: 'Budget', key: 'budget' },
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'cpc' },
  ],
  ClickAdu: [
    { name: 'Budget', key: 'budget' },
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'cpc' },
  ],
  Evadav: [
    { name: 'Budget', key: 'budget' },
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'cpc' },
  ],
  ExoClick: [
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'cpc' },
  ],
  HillTopAds: [
    { name: 'Bid', key: 'cpc' },
  ],
  MegaPush: [
    { name: 'Budget', key: 'budget' },
    { name: 'Bid', key: 'cpc' },
  ],
  PopCash: [
    { name: 'Budget', key: 'budget' },
    { name: 'Bid', key: 'cpc' },
  ],
  Propeller: [
    { name: 'Budget', key: 'budget' },
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'cpc' },
  ],
  PushGround: [
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'cpc' },
  ],
  RichPush: [
    { name: 'Budget', key: 'budget' },
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'cpc' },
  ],
  RtxPops: [
    { name: 'Budget', key: 'budget' },
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'cpc' },
  ],
  ZeroPark: [
    { name: 'Bid', key: 'cpc' },
  ],
  EzMob: [
    { name: 'Budget', key: 'budget' },
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'bid' },
  ],
  AdMaven: [
    { name: 'Budget', key: 'budget' },
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'bid' },
  ],
  Kadam: [
    { name: 'Budget', key: 'budget' },
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'bid' },
  ],
  BidVertiser: [
    { name: 'Daily Budget', key: 'daily_budget' },
    { name: 'Bid', key: 'bid' },
  ],
};

// supports daily budget types unlimited and limited
const supports_daily_budget_types = ['ActiveRevenueMobile', 'ClickAdu', 'Evadav', 'ExoClick', 'RichPush', 'RtxPops', 'Kadam', 'BidVertiser'];
const supports_budget_types = ['ActiveRevenueMobile', 'ClickAdu', 'Evadav', 'RtxPops', 'RichPush', 'Kadam', 'BidVertiser'];
const supports_publisher_bid_change = ['ActiveRevenueMobile', 'Propeller', 'PushGround', 'Evadav', 'ZeroPark', 'RtxPops', 'Kadam', 'BidVertiser', 'EzMob', 'AdMaven'];
// only specif bid options for TrafficSources which support multiple bid types
const bidTypeOptions = {
  ClickAdu: [
    { value: 'cpm', text: 'CPM' },
    { value: 'smartCpm', text: 'Smart CPm' },
    { value: 'cpa', text: 'CPA' },
  ],
  ExoClick: [
    { value: 'cpm', text: 'CPM' },
    { value: 'smartCpm', text: 'Smart CPM' },
    { value: 'smartCpa', text: 'Smart CPA' },
    { value: 'cpa', text: 'CPA' },
  ],
  Propeller: [
    { value: 'cpm', text: 'CPM' },
    { value: 'cpc', text: 'CPC' },
    { value: 'smartCpm', text: 'Smart CPM' },
    { value: 'cpa', text: 'CPA' },
  ],
  Kadam: [
    { value: 'cpc', text: 'CPC' },
    { value: 'cpa', text: 'CPA' },
    { value: 'cpm', text: 'CPM' },
  ],
};

module.exports = { getAvailableTabs, editableFields, supports_publisher_bid_change, bidTypeOptions, supports_daily_budget_types, supports_budget_types, statusFilter, allowedBidChangePropeller };
